/**
 * Format a date string to a human-readable format
 */
export function formatDate(dateString: string | undefined | null): string {
  if (!dateString) return '-'

  try {
    const date = new Date(dateString)
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    })
  } catch {
    return '-'
  }
}

/**
 * Format a date string to include time
 */
export function formatDateTime(dateString: string | undefined | null): string {
  if (!dateString) return '-'

  try {
    const date = new Date(dateString)
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    })
  } catch {
    return '-'
  }
}

/**
 * Format a date as relative time (e.g., "2 days ago", "in 3 days")
 */
export function formatRelativeDate(dateString: string | undefined | null): string {
  if (!dateString) return ''

  try {
    const date = new Date(dateString)
    const now = new Date()
    const diffMs = date.getTime() - now.getTime()
    const diffDays = Math.round(diffMs / (1000 * 60 * 60 * 24))

    if (diffDays === 0) return 'Today'
    if (diffDays === 1) return 'Tomorrow'
    if (diffDays === -1) return 'Yesterday'
    if (diffDays > 0) return `in ${diffDays} days`
    return `${Math.abs(diffDays)} days ago`
  } catch {
    return ''
  }
}

/**
 * Check if a date is in the past
 */
export function isPastDate(dateString: string | undefined | null): boolean {
  if (!dateString) return false

  try {
    return new Date(dateString) < new Date()
  } catch {
    return false
  }
}

/**
 * Check if a date is within N days from now
 */
export function isWithinDays(dateString: string | undefined | null, days: number): boolean {
  if (!dateString) return false

  try {
    const date = new Date(dateString)
    const now = new Date()
    const futureDate = new Date(now.getTime() + days * 24 * 60 * 60 * 1000)
    return date >= now && date <= futureDate
  } catch {
    return false
  }
}

/**
 * Format ISO date string for input[type="date"]
 */
export function toDateInputValue(dateString: string | undefined | null): string {
  if (!dateString) return ''

  try {
    const date = new Date(dateString)
    return date.toISOString().split('T')[0]
  } catch {
    return ''
  }
}
